/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CustomerRegisteryEnabledDto,
  ErrorMessage,
  OrdrServiceSearchResponseDto,
} from '../models';
import {
    CustomerRegisteryEnabledDtoFromJSON,
    CustomerRegisteryEnabledDtoToJSON,
    ErrorMessageFromJSON,
    ErrorMessageToJSON,
    OrdrServiceSearchResponseDtoFromJSON,
    OrdrServiceSearchResponseDtoToJSON,
} from '../models';

export interface GetCustomerRegistryEnabledForLocationRequest {
    locationId: string;
}

export interface GetCustomerRegistryForLocationV1Request {
    locationId: string;
    query?: string;
}

/**
 * 
 */
export class CustomerRegistryControllerApi extends runtime.BaseAPI {

    /**
     */
    async getCustomerRegistryEnabledForLocationRaw(requestParameters: GetCustomerRegistryEnabledForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomerRegisteryEnabledDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling getCustomerRegistryEnabledForLocation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/customer-registry/location/{locationId}/enabled`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomerRegisteryEnabledDtoFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerRegistryEnabledForLocation(requestParameters: GetCustomerRegistryEnabledForLocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomerRegisteryEnabledDto> {
        const response = await this.getCustomerRegistryEnabledForLocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getCustomerRegistryForLocationV1Raw(requestParameters: GetCustomerRegistryForLocationV1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrdrServiceSearchResponseDto>> {
        if (requestParameters.locationId === null || requestParameters.locationId === undefined) {
            throw new runtime.RequiredError('locationId','Required parameter requestParameters.locationId was null or undefined when calling getCustomerRegistryForLocationV1.');
        }

        const queryParameters: any = {};

        if (requestParameters.query !== undefined) {
            queryParameters['query'] = requestParameters.query;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/v1/customer-registry/location/{locationId}`.replace(`{${"locationId"}}`, encodeURIComponent(String(requestParameters.locationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrdrServiceSearchResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async getCustomerRegistryForLocationV1(requestParameters: GetCustomerRegistryForLocationV1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrdrServiceSearchResponseDto> {
        const response = await this.getCustomerRegistryForLocationV1Raw(requestParameters, initOverrides);
        return await response.value();
    }

}
